<ng-container *ngIf="rejectedPrescriptionIds; else: noRejectedPrescriptions">
  <div class="mt-3">Rejected Prescriptions: {{ clientTaskHistoryItem.data.rejectedPrescriptionIds | joinList }}</div>
</ng-container>
<ng-template #noRejectedPrescriptions>
  <div class="mt-3">Rejected Prescriptions: None</div>
</ng-template>
